import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    // TODO: Implement Supabase logout
    navigate('/');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="bg-blue-50 rounded-lg p-2 border border-blue-100">
              <img 
                src="https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/8c2de251b6b4c8837c068d068c7378f0.jfif" 
                alt="Insurance Doctors Logo" 
                className="h-8 w-auto object-contain filter brightness-110 contrast-110"
              />
            </div>
            <div>
              <p className="text-sm text-gray-500">Patient Portal</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-400 hover:text-gray-600 cursor-pointer">
              <i className="ri-notification-3-line text-xl"></i>
            </button>
            
            <div className="relative">
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer"
              >
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-blue-600"></i>
                </div>
                <div className="text-left">
                  <p className="text-sm font-medium text-gray-900">John Smith</p>
                  <p className="text-xs text-gray-500">Policy #12345</p>
                </div>
                <i className="ri-arrow-down-s-line text-gray-400"></i>
              </button>

              {showDropdown && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
                  <div className="py-1">
                    <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer">
                      <i className="ri-user-settings-line mr-2"></i>
                      Account Settings
                    </button>
                    <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer">
                      <i className="ri-customer-service-2-line mr-2"></i>
                      Contact Support
                    </button>
                    <hr className="my-1" />
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    >
                      <i className="ri-logout-box-line mr-2"></i>
                      Sign Out
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
